// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { useRequest } from "redux-query-react";
import { createSelector } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import { isEqual } from "lodash";
import * as runtime from '../runtime';
import { PortfolioFromJSON, } from '../models';
/**
 * Get all portfolios
 * Get portfolios
 */
export function getPortfoliosRaw(requestConfig = {}) {
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    const { meta = {} } = requestConfig;
    const config = {
        url: runtime.BASE_PATH + `/portfolios` + queryString,
        meta,
        update: requestConfig.update || {
            Portfolios: (prevValue, transformedValue) => {
                return { ...prevValue, ...transformedValue };
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'GET',
            headers: headerParameters,
        },
        body: queryParameters,
        transform: requestConfig.transform ? requestConfig.transform : (body, text) => {
            const objResponse = body.map(PortfolioFromJSON);
            return {
                Portfolios: objResponse.reduce((map, obj) => {
                    map[obj.id] = obj;
                    return map;
                }, {})
            };
        }
    };
    config.queryKey = requestConfig.queryKey || `GetPortfolios`;
    return config;
}
/**
* Get all portfolios
* Get portfolios
*/
/**
 * Use this selectors to get a record of all Array<Portfolio>, with their ids as keys
 * @returns A record of Array<Portfolio> object, with their ids as keys
 */
export const usePortfoliosRecordSelector = () => useSelector((state) => state.entities.Portfolios, isEqual);
const PortfoliosArraySelector = createSelector((state) => state.entities.Portfolios, (selectedSubState) => Object.keys(selectedSubState).map((id) => selectedSubState[id]));
/**
 * Use this selector to get a reference to a flat Array<Portfolio>.
 * If you are doing transformation on this object, consider using usePortfoliosRecordSelector instead for performances
 * @returns An array containing all loaded Portfolios
 */
export const usePortfoliosArraySelector = () => useSelector(PortfoliosArraySelector, isEqual);
/**
 * Request hook for Array<Portfolio>
 * @param customQueryConfig TypedQueryConfig options set here will override default options.
 * @returns an array containg the data, query status, and a call for refresh
 * (note : refresh shouldn't be necessary, update to the state should be handle by mutators)
 */
export const useGetPortfolios = (customQueryConfig) => {
    const [querystate, forceRefresh] = useRequest(getPortfoliosRaw(customQueryConfig));
    return [
        usePortfoliosArraySelector(),
        querystate,
        forceRefresh
    ];
};
export function getPortfolios(requestConfig) {
    return getPortfoliosRaw(requestConfig);
}
